/**
 * Utility functions for form data processing
 */

/**
 * Converts all empty strings to null recursively in an object
 * This ensures that backend receives null for unset fields instead of empty strings
 * 
 * @param obj - The object to process
 * @returns The processed object with empty strings converted to null
 */
export function convertEmptyStringsToNull(obj: any): any {
  if (obj === null || obj === undefined) {
    return null;
  }
  
  if (typeof obj === 'string') {
    return obj.trim() === '' ? null : obj;
  }
  
  if (Array.isArray(obj)) {
    return obj.map(item => convertEmptyStringsToNull(item));
  }
  
  if (typeof obj === 'object') {
    const result: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        result[key] = convertEmptyStringsToNull(obj[key]);
      }
    }
    return result;
  }
  
  return obj;
}
